import { render, staticRenderFns } from "./noNav.vue?vue&type=template&id=f7995b10&"
import script from "./noNav.vue?vue&type=script&lang=js&"
export * from "./noNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoFooter: require('/builds/2oYM8JSf/4/mcp/soutez-100-cen/frontend/components/InfoFooter.vue').default})
